import _ from 'underscore';
import { AriaListener } from '@bingads-webui/aria-listener';
import { ConsoleListener } from '@bingads-webui/console-listener';
import { InMemoryListener, InMemorySink } from '@bingads-webui/in-memory-listener';
import {
  getAriaConfig,
  campaignLogTableConfig,
  ContextProcessor,
  DebugProcessor,
  BasicFormatter,
  ApiFormatter,
  ConsoleFormatter,
  LogLevelFilter,
  ApiFilter,
  ConsoleFilter,
  OdataErrorMapper,
  isTestEnvironment,
} from '@bingads-webui-campaign/instrumentation';
import { errorCodes } from './error-codes';

export const initSetup = ({ pageContext, config }) => {
  const getListeners = () => {
    const ariaConfig = getAriaConfig();
    const currentEnv = _.find(_.keys(ariaConfig.tokens), env => document.domain.indexOf(env) > -1);

    // init log formatters
    const basicFormatter = new BasicFormatter({
      applicationSystem: 'campaign',
      applicationSubSystem: 'hotelcenterui',
    });
    const apiFormatter = new ApiFormatter();
    const consoleFormatter = new ConsoleFormatter();

    // init log filters
    const logLevelFilter = new LogLevelFilter();
    const apiFilter = new ApiFilter();
    const consoleFilter = new ConsoleFilter();

    const ariaListener = new AriaListener({
      tenantToken: ariaConfig.tokens[currentEnv],
      flushInterval: ariaConfig.flushInterval,
      batchSize: ariaConfig.batchSize,
      logTableNames: campaignLogTableConfig.logTableNames,
      defaultLogCategory: campaignLogTableConfig.defaultLogCategory,
      formatters: {
        basicFormatter,
        apiFormatter,
      },
      filters: {
        logLevelFilter,
        apiFilter,
      },
    });

    ariaListener.init();
    ariaListener.registerForTeardown();

    const consoleListener = new ConsoleListener({
      filters: {
        consoleFilter,
      },
      formatters: {
        consoleFormatter,
      },
    });

    consoleListener.init();

    const listeners = {
      ariaListener,
      consoleListener,
    };

    if (isTestEnvironment(currentEnv)) {
      window.seleniumLogsSink = new InMemorySink({ maxSize: 100 });
      const inMemoryListener = new InMemoryListener({
        sink: window.seleniumLogsSink,
        formatters: {
          basicFormatter,
          apiFormatter,
        },
        filters: {
          logLevelFilter,
          apiFilter,
        },
      });

      inMemoryListener.init();

      _.extend(listeners, { inMemoryListener });
    }

    return listeners;
  };

  const getProcessors = () => {
    const contextProcessor = new ContextProcessor({ pageContext });
    const debugProcessor = new DebugProcessor({
      isDebugMode: (config && config.get('isDebugMode')) || window.BINGADS_DEBUG,
    });

    const processors = {
      contextProcessor,
      debugProcessor,
    };

    return processors;
  };

  const getErrorMappers = () => {
    const odataErrorMapper = new OdataErrorMapper(errorCodes);

    const errorMappers = {
      odataErrorMapper,
    };

    return errorMappers;
  };

  return {
    getErrorMappers,
    getProcessors,
    getListeners,
  };
};
